import React from "react";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import Messages from "./messages";
import SideActions from "./side-actions";
import getKhattabatStore from "../../../../../stores/khattabat-stores";
import {
  TKhattabatMessage,
  TalkhattabatConversationType,
} from "../../../../../Types";
import { reduce } from "et3-type-guards";
import CreateOneOTwoConversation from "./side-actions/create-one-o-two-conv";
import MarkAsReadButton from "./side-actions/MarkAsReadButton";
import ReactivateConversation from "./side-actions/ReactivateConversation";
import ReactivateKhattabaClient from "./side-actions/ReactivateKhattabaClient";
import getCorePersonalStore from "../../../../../stores/core/core-personal-store";

const Body = withLiteObserverAndTheme<{
  conversationID: string;
  oneOTwoConversationId: string;
  conversationType: TalkhattabatConversationType;
  messages: TKhattabatMessage[];
  alkhattabaUUID: string;
  userUUID: string;
  userID: number;
  peerID: number;
  peerUUID: string;
  isValidSubscription: boolean;
  unreadOneOOneCMessages: number;
  exitedByClient: boolean;
  exitedByMatch: boolean;
  oneOOneCId: string;
  applicationStatus: string
}>((props) => {
  const {
    theme,
    conversationID,
    oneOTwoConversationId,
    conversationType,
    messages,
    alkhattabaUUID,
    userUUID,
    peerID,
    peerUUID,
    isValidSubscription,
    userID,
    unreadOneOOneCMessages,
    exitedByClient,
    exitedByMatch,
    oneOOneCId,
    applicationStatus
  } = props;
  const { colors } = theme;

  const conversationIsOpenState = reduce(
    () => getKhattabatStore().conversationsProps.get(conversationID).isOpened,
    "CLOSED"
  );
  const isConversationOpen = conversationIsOpenState === "OPENED";
  const isAiKhattaba = getCorePersonalStore().isKhattabaAiAdmin.get()


  return isConversationOpen ? (
    <ET3Div
      width={1450}
      height={0}
      alignItems={"center"}
      fDirection={"row"}
      style={{ backgroundColor: colors.all.white }}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={true}
      isScrollable={false}
      onClick={() => { }}
    >
      <Messages
        messages={messages}
        conversationID={conversationID}
        alkhattabaUUID={alkhattabaUUID}
        userUUID={userUUID}
        peerID={peerID}
        peerUUID={peerUUID}
        userID={userID}
        conversationType={conversationType}
        oneOTwoConversationId={oneOTwoConversationId}
        oneOOneCId={oneOOneCId}
        applicationStatus={applicationStatus}
      />
      <Et3Margin top={0} bottom={0} left={10} right={10} />
      {isAiKhattaba ? null : <SideActions
        children={
          <React.Fragment>
            <MarkAsReadButton
              alkhattabaUUID={alkhattabaUUID}
              clientUUID={userUUID}
              unreadOneOOneCMessages={unreadOneOOneCMessages}
              clientID={userID}
              pageType={"clientPage"}
              conversationType={conversationType}
            />
            <CreateOneOTwoConversation
              conversationID={conversationID}
              conversationType={conversationType}
              alkhattabaUUID={alkhattabaUUID}
              userUUID={userUUID}
              userID={userID}
              isValidSubscription={isValidSubscription}
              oneOOneCId={oneOOneCId}
            />
            <ReactivateKhattabaClient
              userID={userID}
              conversationType={conversationType}
              conversationID={conversationID}
              clientUUID={userUUID}
              alkhattabaUUID={alkhattabaUUID}
            />
            <ReactivateConversation
              conversationID={oneOTwoConversationId}
              conversationType={conversationType}
              exitedByMatch={exitedByMatch}
              exitedByClient={exitedByClient}
              alkhattabaUUID={alkhattabaUUID}
              userUUID={userUUID}
              oneOOneCId={oneOOneCId}
            />

          </React.Fragment>
        }
      />}
    </ET3Div>
  ) : null;
});

export default Body;
